const MessagingModule = () => {
  return {
    getInitialNotification: () => {
      return null;
    },

    getToken: async () => {
      return null;
    },

    deleteToken: () => {
      return () => null;
    },

    onMessage: listener => {
      return () => null;
    },

    onNotificationOpenedApp: listener => {
      return () => null;
    },

    onTokenRefresh: listener => {
      return () => null;
    },

    requestPermission: permissions => {
      return Promise.resolve(1);
    },

    registerDeviceForRemoteMessages: () => {
      return Promise.resolve();
    },
    /**
     * @platform ios
     */
    unregisterDeviceForRemoteMessages: () => {
      return Promise.resolve();
    },

    /**
     * @platform ios
     */
    getAPNSToken: () => {
      return Promise.resolve(null);
    },

    hasPermission: async () => {
      return true;
    },

    // https://firebase.google.com/docs/reference/android/com/google/firebase/messaging/FirebaseMessagingService.html#public-void-ondeletedmessages-
    onDeletedMessages: listener => {
      return () => null;
    },

    // https://firebase.google.com/docs/reference/android/com/google/firebase/messaging/FirebaseMessagingService.html#onMessageSent(java.lang.String)
    onMessageSent: listener => {
      return () => {};
    },

    // https://firebase.google.com/docs/reference/android/com/google/firebase/messaging/FirebaseMessagingService.html#onSendError(java.lang.String,%20java.lang.Exception)
    onSendError: listener => {
      return () => null;
    },

    /**
     * Set a handler that will be called when a message is received while the app is in the background.
     * Should be called before the app is registered in `AppRegistry`, for example in `index.js`.
     * An app is considered to be in the background if no active window is displayed.
     * @param handler called with an argument of type messaging.RemoteMessage that must be async and return a Promise
     */
    setBackgroundMessageHandler: handler => {},

    sendMessage: remoteMessage => {
      return null;
    },

    subscribeToTopic: topic => {
      return null;
    },

    unsubscribeFromTopic: topic => {
      return null;
    },

    /**
     * unsupported
     */

    useServiceWorker: () => {
      // eslint-disable-next-line no-console
    },

    usePublicVapidKey: () => {
      // eslint-disable-next-line no-console
      console.warn(
        "firebase.messaging().usePublicVapidKey() is not supported on react-native-firebase.",
      );
    },
  };
};

export { MessagingModule };

export default MessagingModule;
